import React from "react";
import { Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import NewSelect from "react-select";
import { invoicesTypeList } from "../../labels/options_en";
import PullDown from "../../commonComponents/PullDown";

const FilterSection = ({ 
  type, 
  fromDate, 
  toDate, 
  setFromDate, 
  setToDate, 
  invoiceType, 
  setInvoiceType, 
  categoryFilter, 
  setCategoryFilter, 
  categories, 
  onSearch, 
  onReset 
}) => {
  const formatDate = (date) => {
    return date ? date.toLocaleDateString() : '';
  };

  return (
    <div className="filter-container">
      <div className="d-flex flex-row">
        <Col lg={2} className="p-0 pl-3">
          <label htmlFor="start" className="filterLabelInput maintenanceLabels">
            From
          </label>
          <DatePicker
            autoComplete="off"
            dateFormat="yyyy-MM-dd"
            className="form-control filterInput2"
            name="start"
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
          />
        </Col>
        <Col lg={2} className="p-0 pl-3">
          <label htmlFor="to" className="filterLabelInput maintenanceLabels">
            To
          </label>
          <DatePicker
            autoComplete="off"
            dateFormat="yyyy-MM-dd"
            className="form-control filterInput2"
            name="end"
            selected={toDate}
            onChange={(date) => setToDate(date)}
          />
        </Col>
        {type === 'invoices' ? (
          <Col lg={3} className="p-0 pl-3">
            <label htmlFor="invoiceType" className="filterLabelInput maintenanceLabels">
              Invoice Type
            </label>
            <NewSelect
              autocomplete="off"
              value={invoiceType}
              isMulti={true}
              onChange={(selectedType) => setInvoiceType(selectedType)}
              options={invoicesTypeList}
              isClearable
            />
          </Col>
        ) : (
          <Col lg={3}>
            <label className="filterLabelInput maintenanceLabels" htmlFor="categoryFilter">
              Category
            </label>
            <PullDown
              defaultValue={categoryFilter}
              labelInside={false}
              pulldownFor={"categoryFilter"}
              forceBlank={true}
              setValue={setCategoryFilter}
              options={categories}
            />
          </Col>
        )}
        <Col lg={2} className="p-0">
          <div style={{ marginTop: 35 }} border="0">
            <div className="d-flex flex-row align-items-start">
              <button
                onClick={onSearch}
                className="btn btn-primary search-button"
              >
                Go
              </button>
              <button
                onClick={onReset}
                className="btn btn-primary reset-button"
              >
                Reset
              </button>
            </div>
          </div>
        </Col>
      </div>
    </div>
  );
};

export default FilterSection; 